export const ChartSkeleton = defineComponent(() => {
  return () => (
    <div class="w-full max-w-full min-w-0 bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div class="px-5 pt-4 pb-3 border-b border-gray-100">
        <div class="h-[22px] w-48 rounded bg-gray-200 animate-pulse" />
      </div>
      <div class="px-5 pt-3.5">
        <div class="flex flex-wrap gap-2.5">
          {[68, 52, 84, 60].map((w, i) => (
            <div
              key={`legend-sk-${i}`}
              class="h-3 rounded bg-gray-200 animate-pulse"
              style={{
                width: `${w}px`,
                animationDelay: `${i * 120}ms`,
              }}
            />
          ))}
        </div>
      </div>
      <div class="px-5 py-5">
        <div class="h-[200px] w-full rounded bg-gray-200 animate-pulse" />
      </div>
    </div>
  );
});

export const CardSkeleton = defineComponent(() => {
  return () => (
    <div class="w-full max-w-full min-w-0 bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div class="px-5 pt-4 pb-2">
        <div class="h-5 w-32 rounded bg-gray-200 animate-pulse" />
      </div>
      <div class="px-5 pt-1 pb-4 border-b border-gray-100">
        <div
          class="h-3 w-20 rounded bg-gray-200 animate-pulse"
          style={{ animationDelay: "80ms" }}
        />
        <div
          class="h-7 w-56 rounded bg-gray-200 animate-pulse mt-2"
          style={{ animationDelay: "160ms" }}
        />
      </div>
      <div class="divide-y divide-gray-100">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={`card-sk-row-${i}`}
            class="flex items-baseline justify-between px-5 py-3.5"
          >
            <div
              class="h-3 w-14 rounded bg-gray-200 animate-pulse"
              style={{ animationDelay: `${240 + i * 100}ms` }}
            />
            <div
              class="h-3 w-24 rounded bg-gray-200 animate-pulse"
              style={{ animationDelay: `${280 + i * 100}ms` }}
            />
          </div>
        ))}
      </div>
    </div>
  );
});
